export const STANDARD_NUMBER_OF_BITS = 40;
export const HID_37_NUMBER_OF_BITS = 37;